import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
    fetchLegacyStats,
    fetchYearlySales,
    fetchSalesByLocation,
    updateCustomerFilters,
    updatePaymentFilters,
    changeYear,
} from '../../store/modules/dashboard/dashboardActions';

import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    PointElement,
    Filler,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import LegacyStatsCards from './components/LegacyStatsCards';
import LegacyYearlySalesChart from './components/LegacyYearlySalesChart';
import SalesByLocationChart from './components/SalesByLocationChart';
import StatsCards from './components/StatsCards';
import RevenueTrendChart from './components/RevenueTrendChart';
import PaymentMethodsDonut from './components/PaymentMethodsDonut';
import OrderTypeDonut from './components/OrderTypeDonut';
import YearlySalesChart from './components/YearlySalesChart';
import BranchComparisonChart from './components/BranchComparisonChart';
import StockUsageTrend from './components/StockUsageTrend';
import TopEmployeesList from './components/TopEmployeesList';
import RecentCustomersList from './components/RecentCustomersList';
import RecentPaymentsList from './components/RecentPaymentsList';
import RecentStockUsageList from './components/RecentStockUsageList';

ChartJS.register(
    ArcElement, Tooltip, Legend, ChartDataLabels,
    CategoryScale, LinearScale, BarElement, LineElement, PointElement, Filler
);
ChartJS.defaults.set('plugins.datalabels', { display: false });

const Dashboard = () => {
    const dispatch = useDispatch();
    const {
        stats,
        legacyStats,
        yearlySales,
        salesByLocation,
        branchComparison,
        branchOptions,
        topEmployees,
        recentCustomers,
        recentPayments,
        recentStockUsage,
        revenueTrend,
        paymentMethodsSummary,
        stockUsageTrend,
        lowStockItems,
        customerFilters,
        paymentFilters,
        loading,
        errors,
        selectedYear,
    } = useSelector((state) => state.dashboard);

    const hasInitialized = useRef(false);

    useEffect(() => {
        if (!hasInitialized.current) {
            hasInitialized.current = true;
            dispatch(fetchLegacyStats());
            dispatch(fetchYearlySales());
            dispatch(fetchSalesByLocation());
        }
    }, [dispatch]);

    const handleYearChange = (year) => {
        dispatch(changeYear(year));
        dispatch(fetchYearlySales(year));
    };

    return (
        <div className="container-fluid pb-3 dashboard-page">
            {/* === OLD DASHBOARD SECTION === */}
            <div className="row g-3 mb-3">
                <div className="col-12">
                    <LegacyStatsCards stats={legacyStats} loading={loading.legacyStats} error={errors.legacyStats} />
                </div>
            </div>
            <div className="row g-4 mb-4">
                <div className="col-12 col-xl-8">
                    <LegacyYearlySalesChart
                        yearlySales={yearlySales}
                        loading={loading.yearlySales}
                        selectedYear={selectedYear}
                        onYearChange={handleYearChange}
                    />
                </div>
                <div className="col-12 col-xl-4">
                    <SalesByLocationChart
                        salesByLocation={salesByLocation}
                        loading={loading.salesByLocation}
                    />
                </div>
            </div>

            
        </div>
    );
};

export default Dashboard;
